import React from 'react';

import type { DetailBackLinkProps } from './types';

import styles from './styles.module.scss';

export const DetailBackLink: React.FC<DetailBackLinkProps> = ({ label, onClick }) => {
  return (
    <a
      href="#"
      className={styles.backLink}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      aria-label={label}
    >
      {label}
    </a>
  );
};
